import { render, staticRenderFns } from "./InputTable.vue?vue&type=template&id=64c83db3&scoped=true&"
import script from "./InputTable.vue?vue&type=script&lang=js&"
export * from "./InputTable.vue?vue&type=script&lang=js&"
import style0 from "./InputTable.vue?vue&type=style&index=0&id=64c83db3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c83db3",
  null
  
)

export default component.exports